import React, { useState } from 'react';
import './ThreeDViewer.css';

const ThreeDViewer = ({ imageUrl, productName }) => {
  const [currentAngle, setCurrentAngle] = useState('front');
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [rotation, setRotation] = useState(0);

  const angles = [
    { id: 'front', label: 'Front', degrees: 0 },
    { id: 'left', label: 'Left', degrees: -90 },
    { id: 'back', label: 'Back', degrees: 180 },
    { id: 'right', label: 'Right', degrees: 90 }
  ];

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.clientX);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    
    const deltaX = e.clientX - startX;
    const newRotation = rotation + deltaX * 0.5;
    setRotation(newRotation);
    
    // Determine which angle based on rotation
    const normalizedRotation = ((newRotation % 360) + 360) % 360;
    if (normalizedRotation < 45 || normalizedRotation >= 315) {
      setCurrentAngle('front');
    } else if (normalizedRotation >= 45 && normalizedRotation < 135) {
      setCurrentAngle('right');
    } else if (normalizedRotation >= 135 && normalizedRotation < 225) {
      setCurrentAngle('back');
    } else {
      setCurrentAngle('left');
    }
    
    setStartX(e.clientX);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleAngleClick = (angle) => {
    setCurrentAngle(angle.id);
    setRotation(angle.degrees);
  };

  return (
    <div className="threed-viewer">
      <div className="viewer-header">
        <h3>🔄 360° View: {productName}</h3>
        <p className="viewer-hint">Click and drag to rotate • Click angles below for quick view</p>
      </div>
      
      <div 
        className="viewer-canvas"
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >
        <div 
          className="viewer-image-container"
          style={{
            transform: `rotateY(${rotation}deg)`,
            transition: isDragging ? 'none' : 'transform 0.3s ease'
          }}
        >
          <img 
            src={imageUrl} 
            alt={`${productName} - ${currentAngle} view`}
            draggable={false}
          />
        </div>
        
        <div className="angle-indicator">
          {currentAngle.charAt(0).toUpperCase() + currentAngle.slice(1)} View
        </div>
      </div>
      
      <div className="angle-selector">
        {angles.map(angle => (
          <button
            key={angle.id}
            className={`angle-btn ${currentAngle === angle.id ? 'active' : ''}`}
            onClick={() => handleAngleClick(angle)}
          >
            {angle.label}
          </button>
        ))}
      </div>
      
      <div className="viewer-note">
        <small>ℹ️ 3D rotation is simulated. Full multi-angle photos require additional processing.</small>
      </div>
    </div>
  );
};

export default ThreeDViewer;